import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'instrumentList',
    'switchNowButton',
    'joinWaitingListButton',
    'cancelAndJoinButton',
    'instrumentChoice',
    'buttons',
    'undoTransferRequestButton', // Added this target
  ];

  static values = {
    currentInstrument: String,
    requestedTransfer: Boolean,
  };

  connect() {
    this.updateButtonVisibility();
  }

  handleInstrumentChange(event) {
    this.updateButtonVisibility();

    // Get the selected instrument
    let selectedInstrument = this.instrumentListTarget.querySelector('input:checked');
    if (!selectedInstrument) return; // Exit if no instrument is selected

    // Get the current instrument of the student
    const currentInstrument = this.currentInstrumentValue;
    const requestedTransfer = this.requestedTransferValue;

    // Check if the selected instrument is the same as the current instrument
    if (currentInstrument === selectedInstrument.value && requestedTransfer) {
      this.switchNowButtonTarget.classList.add('hidden');
      this.joinWaitingListButtonTarget.classList.add('hidden');
      this.cancelAndJoinButtonTarget.classList.add('hidden');
      this.undoTransferRequestButtonTarget.classList.remove('hidden');
    } else {
      let spaces = parseInt(selectedInstrument.dataset.spaces);

      if (spaces > 0) {
        this.switchNowButtonTarget.classList.remove('hidden');
        this.joinWaitingListButtonTarget.classList.add('hidden');
        this.cancelAndJoinButtonTarget.classList.add('hidden');
        this.undoTransferRequestButtonTarget.classList.add('hidden');
      } else {
        this.switchNowButtonTarget.classList.add('hidden');
        this.joinWaitingListButtonTarget.classList.remove('hidden');
        this.cancelAndJoinButtonTarget.classList.remove('hidden');
        this.undoTransferRequestButtonTarget.classList.add('hidden');
      }
    }
  }

  updateButtonVisibility() {
    const selectedInstrument = this.instrumentChoiceTargets.find((choice) => choice.checked);
    if (selectedInstrument) {
      this.buttonsTarget.classList.remove('hidden');
    } else {
      this.buttonsTarget.classList.add('hidden');
    }
  }
}
